




















































































































































































































































































































































































































































































































































































































































































import { defineComponent } from '@nuxtjs/composition-api'
export const PROVIDERS_WITH_TERMS = [1000223313, 1000031091]

export default defineComponent({
  props: {
    providerId: {
      type: Number,
      required: true
    }
  },
  setup() {}
})
